import { config } from './config';
import firebase from 'firebase';

firebase.initializeApp(config);

export const auth = firebase.auth();

export const fireauth = firebase.auth;

const settings = {timestampsInSnapshots: true};
firebase.firestore().settings(settings);
export const firestore = firebase.firestore();

export const storage = firebase.storage();

export const firebasestore = firebase.firestore;


// WEBPACK FOOTER //
// ./src/firebase/firebase.js